import { createFileRoute, redirect } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'
import { visibleNodeTypes } from '#/components/ontology/model'
import { ensureOntologyDoc } from '#/components/ontology/use-ontology-explorer'

// There is nothing useful to say about the ontology as a whole that a type
// page doesn't say better, so land on the first type rather than an interstitial.
export const Route = createFileRoute('/_authed/accounts/$accountId/ontology/')({
  loaderDeps: ({ search }) => ({ v: search.v }),
  loader: async ({ context, params, deps }) => {
    const doc = await ensureOntologyDoc(context, params.accountId, deps.v)
    const first = doc && visibleNodeTypes(doc)[0]
    if (first) {
      throw redirect({
        to: '/accounts/$accountId/ontology/types/$typeName',
        params: { accountId: params.accountId, typeName: first.name },
        search: { v: deps.v },
        replace: true,
      })
    }
  },
  component: EmptyOntology,
})

// Only reachable when the version exposes no node types at all.
function EmptyOntology() {
  const { t } = useTranslation()
  return (
    <p className="p-8 text-sm text-muted-foreground">{t('ontology.empty')}</p>
  )
}
